import { render } from "./ModalClusterConfig.vue?vue&type=template&id=0bd6f8e9&scoped=true&ts=true"
import script from "./ModalClusterConfig.vue?vue&type=script&lang=ts"
export * from "./ModalClusterConfig.vue?vue&type=script&lang=ts"

import "./ModalClusterConfig.vue?vue&type=style&index=0&id=0bd6f8e9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd6f8e9"]])

export default __exports__